/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CreateCaseNoteResponse
 */
export interface CreateCaseNoteResponse {
    /**
     *
     * @type {string}
     * @memberof CreateCaseNoteResponse
     */
    message: string;
}

/**
 * Check if a given object implements the CreateCaseNoteResponse interface.
 */
export function instanceOfCreateCaseNoteResponse(value: object): value is CreateCaseNoteResponse {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function CreateCaseNoteResponseFromJSON(json: any): CreateCaseNoteResponse {
    return CreateCaseNoteResponseFromJSONTyped(json, false);
}

export function CreateCaseNoteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCaseNoteResponse {
    if (json == null) {
        return json;
    }
    return {

        'message': json['message'],
    };
}

export function CreateCaseNoteResponseToJSON(value?: CreateCaseNoteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {

        'message': value['message'],
    };
}

